"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("../object/isNil"));

var isNumber = function isNumber(numToTest) {
  if ((0, _isNil["default"])(numToTest)) return false;
  if (typeof numToTest !== 'number') return false;
  if (Number.isNaN(numToTest)) return false;
  return Number.isFinite(numToTest);
};

var _default = isNumber;
exports["default"] = _default;